var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData.length > 1)?_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[(_vm.isLoading)?_c('v-progress-linear',{attrs:{"indeterminate":true,"color":"primary"}}):_c('GChart',{attrs:{"type":"BarChart","data":_vm.chartData,"options":_vm.chartOptions,"width":"100%"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }